var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('site-header',{attrs:{"restaurant":_vm.restaurant}}),_c('router-view'),_c('site-footer',{attrs:{"AboutCo":_vm.AboutCo,"Copyrights":_vm.CRights}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }